import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=cb3bf3f2"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb3bf3f2')) {
      api.createRecord('cb3bf3f2', component.options)
    } else {
      api.reload('cb3bf3f2', component.options)
    }
    module.hot.accept("./Buttons.vue?vue&type=template&id=cb3bf3f2", function () {
      api.rerender('cb3bf3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Components/Buttons.vue"
export default component.exports